import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Profile() {
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);

  const menuItems = [
    {
      icon: 'ri-user-line',
      title: 'تعديل البيانات',
      subtitle: 'الاسم، الجوال، البريد',
      action: () => {},
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'العناوين',
      subtitle: 'إدارة عناوين التوصيل',
      action: () => {},
      color: 'from-green-500 to-green-600'
    },
    {
      icon: 'ri-bank-card-line',
      title: 'طرق الدفع',
      subtitle: 'البطاقات المحفوظة',
      action: () => {},
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-notification-line',
      title: 'الإشعارات',
      subtitle: 'إدارة التنبيهات',
      action: () => {},
      color: 'from-orange-500 to-orange-600'
    },
    {
      icon: 'ri-global-line',
      title: 'اللغة',
      subtitle: 'العربية',
      action: () => {},
      color: 'from-cyan-500 to-cyan-600'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'الدعم الفني',
      subtitle: 'تواصل معنا',
      action: () => {},
      color: 'from-pink-500 to-pink-600'
    },
    {
      icon: 'ri-information-line',
      title: 'عن التطبيق',
      subtitle: 'الإصدار 1.0.0',
      action: () => {},
      color: 'from-indigo-500 to-indigo-600'
    }
  ];

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-20" style={{ fontFamily: 'Cairo, sans-serif' }}>
      {/* Top Section */}
      <div className="bg-gradient-to-r from-[#0D47A1] to-[#1976D2] pt-12 pb-24 px-4 rounded-b-[2rem]">
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-white text-xl font-bold">حسابي</h1>
          <button className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
            <i className="ri-settings-3-line text-white text-xl"></i>
          </button>
        </div>

        {/* Profile Card */}
        <div className="bg-white rounded-2xl p-5 shadow-lg">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-20 h-20 bg-gradient-to-br from-[#0D47A1] to-[#1976D2] rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-white text-2xl font-bold">م</span>
            </div>
            <div className="flex-1">
              <h2 className="text-[#212121] text-lg font-bold mb-1">محمد أحمد</h2>
              <p className="text-gray-500 text-sm mb-1">mohammed@email.com</p>
              <p className="text-gray-500 text-sm">0501234567</p>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-3 pt-4 border-t border-gray-100">
            <div className="text-center">
              <div className="text-[#0D47A1] text-2xl font-bold mb-1">24</div>
              <div className="text-gray-500 text-xs">الطلبات</div>
            </div>
            <div className="text-center border-x border-gray-100">
              <div className="text-[#4CAF50] text-2xl font-bold mb-1">18</div>
              <div className="text-gray-500 text-xs">المكتملة</div>
            </div>
            <div className="text-center">
              <div className="text-[#FF8F00] text-2xl font-bold mb-1">4.8</div>
              <div className="text-gray-500 text-xs">التقييم</div>
            </div>
          </div>
        </div>
      </div>

      {/* Menu Items */}
      <div className="px-4 -mt-16">
        <div className="space-y-3">
          {menuItems.map((item, index) => (
            <button
              key={index}
              onClick={item.action}
              className="w-full bg-white rounded-2xl p-4 flex items-center gap-4 shadow-sm active:scale-95 transition-transform"
            >
              <div className={`w-12 h-12 bg-gradient-to-br ${item.color} rounded-xl flex items-center justify-center flex-shrink-0`}>
                <i className={`${item.icon} text-white text-xl`}></i>
              </div>
              <div className="flex-1 text-right">
                <h3 className="text-[#212121] font-bold text-sm mb-0.5">{item.title}</h3>
                <p className="text-gray-500 text-xs">{item.subtitle}</p>
              </div>
              <i className="ri-arrow-left-s-line text-gray-400 text-xl"></i>
            </button>
          ))}

          {/* Dark Mode Toggle */}
          <div className="bg-white rounded-2xl p-4 flex items-center gap-4 shadow-sm">
            <div className="w-12 h-12 bg-gradient-to-br from-gray-700 to-gray-900 rounded-xl flex items-center justify-center flex-shrink-0">
              <i className="ri-moon-line text-white text-xl"></i>
            </div>
            <div className="flex-1 text-right">
              <h3 className="text-[#212121] font-bold text-sm mb-0.5">الوضع الليلي</h3>
              <p className="text-gray-500 text-xs">تفعيل الوضع المظلم</p>
            </div>
            <button
              onClick={() => setDarkMode(!darkMode)}
              className={`w-14 h-8 rounded-full transition-colors relative ${
                darkMode ? 'bg-[#0D47A1]' : 'bg-gray-300'
              }`}
            >
              <div className={`absolute top-1 w-6 h-6 bg-white rounded-full transition-transform ${
                darkMode ? 'left-1' : 'right-1'
              }`}></div>
            </button>
          </div>

          {/* Logout Button */}
          <button
            onClick={() => navigate('/auth')}
            className="w-full bg-white border-2 border-red-500 text-red-500 rounded-2xl p-4 font-bold flex items-center justify-center gap-2 shadow-sm active:scale-95 transition-transform"
          >
            <i className="ri-logout-box-line text-xl"></i>
            تسجيل الخروج
          </button>
        </div>
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
        <div className="grid grid-cols-5 h-16">
          <button onClick={() => navigate('/home')} className="flex flex-col items-center justify-center gap-1">
            <i className="ri-home-5-line text-gray-400 text-xl"></i>
            <span className="text-gray-400 text-[0.625rem]">الرئيسية</span>
          </button>
          <button onClick={() => navigate('/products')} className="flex flex-col items-center justify-center gap-1">
            <i className="ri-grid-line text-gray-400 text-xl"></i>
            <span className="text-gray-400 text-[0.625rem]">المنتجات</span>
          </button>
          <button onClick={() => navigate('/cart')} className="flex flex-col items-center justify-center gap-1 relative">
            <i className="ri-shopping-cart-line text-gray-400 text-xl"></i>
            <span className="text-gray-400 text-[0.625rem]">السلة</span>
            <span className="absolute top-1 right-1/2 translate-x-3 w-4 h-4 bg-[#FF8F00] text-white text-[0.5rem] font-bold rounded-full flex items-center justify-center">3</span>
          </button>
          <button onClick={() => navigate('/orders')} className="flex flex-col items-center justify-center gap-1">
            <i className="ri-file-list-line text-gray-400 text-xl"></i>
            <span className="text-gray-400 text-[0.625rem]">الطلبات</span>
          </button>
          <button className="flex flex-col items-center justify-center gap-1">
            <i className="ri-user-fill text-[#0D47A1] text-xl"></i>
            <span className="text-[#0D47A1] text-[0.625rem] font-medium">الحساب</span>
          </button>
        </div>
      </div>
    </div>
  );
}